import { styled } from "@mui/material";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { Link, Typography } from "@kaltura/ds-react-components";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

// See Kms_Type_Media_Metadata_Category_Props in php
export enum MediaCategorySize {
    SMALL = "small",
    MEDIUM = "medium",
}

export interface MediaCategoryProps {
    categoryName: string;
    iconUrl?: string;
    actionLabel: string;
    actionUrl: string;
    size?: MediaCategorySize;
    className?: string;
}

/**
 * Category context component for the media page metadata
 */
export const MediaCategory = ({
    categoryName,
    iconUrl,
    actionLabel,
    actionUrl,
    size = MediaCategorySize.SMALL,
    className,
}: MediaCategoryProps) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const onLinkClick = () => {
        sendButtonAnalytics("Go to context category", ButtonClickAnalyticsType.LINK);
    };

    return (
        <StyledContainer className={`kms-ds-media-page-metadata-category ${className || ""}`}>
            {iconUrl && (
                <StyledIcon
                    className={"kms-ds-media-page-category-icon"}
                    style={{ backgroundImage: `url(${iconUrl})` }}
                    iconSize={size}
                />
            )}
            <Box className={"kms-ds-media-page-category-name-and-link"}>
                <StyledLine variant={"body2Highlight"}>{categoryName}</StyledLine>
                <StyledLine variant={"body2Highlight"}>
                    <Link href={actionUrl} size={"small"} onClick={onLinkClick}>
                        {actionLabel}
                    </Link>
                </StyledLine>
            </Box>
        </StyledContainer>
    );
};

export default MediaCategory;

const StyledContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
}));

const StyledIcon = styled(Box)<{ iconSize: MediaCategorySize }>(({ iconSize }) => {
    const size = iconSize === MediaCategorySize.MEDIUM ? 48 : 36;
    return {
        width: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    };
});

const StyledLine = styled(Typography)({
    display: "block",
});
